import { invokeAuthedFunction } from "@/lib/invokeAuthedFunction";

/** search-candidates with a fresh token, retry on 401, and login redirect when the session is over. */
export function invokeSearchCandidates<T = any>(body: Record<string, unknown>) {
  return invokeAuthedFunction<T>("search-candidates", body);
}
